/**
* Resource Card JS
* -----------------------------------------------------------------------------
*
* All the JS for the Resource Card component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'resource-card',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function doFilter( url ) {
        const removePagintionUrl = url.replace( /\/page\/\d+\//, '/' );
        $.ajax( {
          type: 'GET',
          url: removePagintionUrl,
          beforeSend: function( xhr ) {
            doingAjax = true;
          },
          success: function( returnedHtml ) {
            $( '#resource-grid' ).html( $( returnedHtml ).find( '#resource-grid' ) );
            $( '#resource-filter' ).html( $( returnedHtml ).find( '#resource-filter' ) );
            $( 'form.resource-library__filter-form' ).on( 'submit', function( e ) {
              e.preventDefault();
              const newUrl = buildUrlFromState( getFormState() );
              doFilter( newUrl );
              return false;
            } );
            window.easyToggleState();
            $( 'form.resource-library__filter-form input' ).on( 'change', function() {
              $( 'form.resource-library__filter-form' ).trigger( 'submit' );
            } );
            $( '.resource-filter__clear' ).on( 'click', function( e ) {
              e.preventDefault();
              $( 'form.resource-library__filter-form input[type="checkbox"]' ).prop( 'checked', false );
              const baseUrl = window.location.toString().split( '?' )[0];
              window.history.pushState( null, '', baseUrl );
              doFilter( baseUrl );
            } );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }


      function buildUrlFromState( values ) {
        const url = new URL( window.location.href );
        const searchParams = new URLSearchParams();
        values.forEach( ( filterType ) => {
          searchParams.append( `${filterType.name}[]`, filterType.value );
        } );

        url.search = searchParams.toString();
        const newUrl = url.toString();
        const removePagintionUrl = newUrl.replace( /\/page\/\d+\//, '/' );
        window.history.pushState( null, '', removePagintionUrl );
        return newUrl;
      }

      function getFormState() {
        return $( 'form.resource-library__filter-form' ).serializeArray();
      }
      $( 'form.resource-library__filter-form input' ).on( 'change', function() {
        $( 'form.resource-library__filter-form' ).trigger( 'submit' );
      } );
      $( '.resource-filter__clear' ).on( 'click', function( e ) {
        e.preventDefault();
        $( 'form.resource-library__filter-form input[type="checkbox"]' ).prop( 'checked', false );
        const baseUrl = window.location.toString().split( '?' )[0];
        window.history.pushState( null, '', baseUrl );
        doFilter( baseUrl );
      } );
      $( 'form.resource-library__filter-form' ).on( 'submit', function( e ) {
        e.preventDefault();
        const newUrl = buildUrlFromState( getFormState() );
        doFilter( newUrl );
        return false;
      } );

      window.onpopstate = function( e ) {
        doFilter( window.location.toString() );
      };
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'resource-card', COMPONENT );
} )( app );
